import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { PageResponse } from "app/common/Model/Shared";

import { cancleCheckIn } from "app/services/ReceptionService";
import {
  getAppointmentById,
  pagingAppointment,
  updateAppointmentStatus,
  saveOrUpdateAppointmentByStaff,
  countingByDayConfirm,
  updateAppointmentStatusAndCheckIn,
  exportExcelAppointmentList,
  checkOutAppointmentAuto,
} from "app/services/AppointmentService";
import { Appointment } from "app/common/Model/Appointment";
import { APPOINTMENT_STATUS } from "app/common/LocalConst";
const DEFAULT_VALUE_CHECKOUT = {
  departmentIds: [],
  visitDate: new Date(),
};

const DEFAULT_APPOINTMENT_BY_DAY = {
  customersAttended: 0,
  customersNotAttended: 0,
  customersCancelled: 0,
  customersFrom7To10: 0,
  customersFrom10To13: 0,
  customersFrom13To17: 0,
  customersFrom17To20: 0,
};
export default class AppointmentStore {
  searchAppointment = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    leadSourceIds: [],
    leadSourceDetailIds: [],
  };
  pageAppointment = new PageResponse();
  openFormCreateOrEdit = false;
  openConfirmUpdateState = null;
  initialAppointment = null;
  openConfirmDelete = false;
  countingByDay = { ...DEFAULT_APPOINTMENT_BY_DAY };
  openAppointmentStatusAndCheckin = null;
  openConfirmCheckInMessage = null;
  openConfirmCheckIn = null;
  openCheckout = false;
  initDataCheckOut = {
    ...DEFAULT_VALUE_CHECKOUT,
  };
  constructor() {
    makeAutoObservable(this);
  }

  pagingAppointment = async () => {
    const search = this.normalizeSearchAppointmentList(this.searchAppointment);

    return await pagingAppointment({ ...search })
      .then(({ data }) => {
        this.pageAppointment = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu lịch hẹn khách hàng có lỗi");
      });
  };

  handleCountingByDay = async () => {
    let { departmentId, fromDate, toDate, ...ortherData } =
      this.searchAppointment;

    countingByDayConfirm({
      departmentId: departmentId?.id,
      fromDate,
      toDate,
    })
      .then(({ data }) => {
        this.countingByDay = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy thông tin lịch hẹn có lỗi");
      });
  };

  handleChangeFormSearch = (searchAppointment) => {
    this.searchAppointment = {
      ...this.searchAppointment,
      ...searchAppointment,
    };
    this.pagingAppointment();
    this.handleCountingByDay();
  };

  handleChangeFormSearchTab = (searchAppointment) => {
    this.searchAppointment = {
      ...this.searchAppointment,
      ...searchAppointment,
    };
    this.pagingAppointment();
  };

  handleOpenFormCreateOrEdit = (appointment) => {
    if (Boolean(appointment)) {
      getAppointmentById(appointment?.id).then(({ data }) => {
        this.initialAppointment = { ...data };
        this.openFormCreateOrEdit = true;
      });
    } else {
      this.initialAppointment = new Appointment();
      this.openFormCreateOrEdit = true;
    }
  };

  setOpenConfirmAppointment = (state) => {
    this.openFormCreateOrEdit = state;
  };

  handleUpdateAppointmentStatusAndCheckin = (status) => {
    this.openAppointmentStatusAndCheckin = status;
  };

  handleUpdateAppointmentStatus = (dto) => {
    this.openConfirmUpdateState = dto;
  };

  updateAppointmentStatusAndCheckIn = async (data) => {
    updateAppointmentStatusAndCheckIn({ ...data })
      .then(({ data }) => {
        if (data && data?.responseStatus === false) {
          this.openConfirmCheckIn = data?.responseDetail;
        } else {
          toast.success("Cập nhật lịch hẹn và check in thành công!");
          this.handleCountingByDay();
          this.pagingAppointment();

          this.openAppointmentStatusAndCheckin = null;
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Cập nhật lịch hẹn và check in có lỗi");
      });
  };

  updateAppointmentStatus = async () => {
    updateAppointmentStatus(this.openConfirmUpdateState)
      .then(({ data }) => {
        toast.success("Cập nhật lịch hẹn thành công!");
        this.handleCountingByDay();
        this.pagingAppointment();
        this.openConfirmUpdateState = null;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Cập nhật lịch hẹn có lỗi");
      });
  };

  saveOrUpdateAppoint = (obj, { setSubmitting }) => {
    return saveOrUpdateAppointmentByStaff({
      ...obj,
      updateAppointmentCrm: true,
    })
      .then(({ data }) => {
        toast.success("Cập nhật lịch hẹn thành công!");
        this.openFormCreateOrEdit = false;
        this.pagingAppointment();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Cập nhật lịch có lỗi");
      })
      .finally(() => setSubmitting(false));
  };

  handleCloseCreateOrEditPopup = () => {
    this.openFormCreateOrEdit = false;
  };

  handleCloseConfirmDialog = () => {
    this.openConfirmDelete = false;
    this.initialAppointment = new Appointment();
  };

  setOpenConfirmCheckInMessage = (state) => {
    this.openConfirmCheckInMessage = state;
  };

  setOpenConfirmCheckIn = (state) => {
    this.openConfirmCheckIn = state;
  };

  handleExportExcelAppointmentList = async (searchObj) => {
    const search = this.normalizeSearchAppointmentList(searchObj);
    try {
      const response = await exportExcelAppointmentList(search);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "DS_LICH_HEN.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
    }
  };

  normalizeSearchAppointmentList = (rawSearch = {}) => {
    const {
      departmentId,
      telesaleId,
      listAppointmentStatus,
      leadSourceIds,
      leadSourceDetailIds,
      ...rest
    } = rawSearch;

    return {
      ...rest,
      telesaleId: telesaleId?.id || null,
      departmentId: departmentId?.id || null,
      leadSourceIds: Array.isArray(leadSourceIds)
        ? leadSourceIds?.map((el) => el?.id)
        : [],
      leadSourceDetailIds: Array.isArray(leadSourceDetailIds)
        ? leadSourceDetailIds?.map((el) => el?.id)
        : [],
      listAppointmentStatus: Array.isArray(listAppointmentStatus)
        ? listAppointmentStatus.map((item) => item.value)
        : [],
    };
  };

  setOpenCheckout = () => {
    this.openCheckout = true;
  };

  handleClosePopupCheckout = () => {
    this.openCheckout = false;
  };

  handleOpenCheckout = (obj, { setSubmitting }) => {
    return checkOutAppointmentAuto(obj)
      .then(({ data }) => {
        this.openCheckout = false;
        toast.success(`Đã check out ${data} bản ghi`);
        return data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Check out thông tin có lỗi");
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  resetStore = () => {
    this.searchAppointment = {
      ...new SearchObject(),
      fromDate: new Date(),
      toDate: new Date(),
      // appointmentType: APPOINTMENT_TYPE[0].value,
    };
    this.pageAppointment = new PageResponse();
    this.openFormCreateOrEdit = false;
    this.openConfirmUpdateState = null;
    this.initialAppointment = null;
    this.countingByDay = { ...DEFAULT_APPOINTMENT_BY_DAY };
  };
  resetStoreDetail = () => {
    //hàm này để trong trang chi tiết KH thì để fromdate từ đầu năm
    this.searchAppointment = {
      ...new SearchObject(),
      fromDate: new Date(),
      toDate: new Date(),
      patientId: null,
      // appointmentType: APPOINTMENT_TYPE[0].value,
    };
    this.pageAppointment = new PageResponse();
    this.openFormCreateOrEdit = false;
    this.openConfirmUpdateState = null;
    this.initialAppointment = null;
    this.countingByDay = { ...DEFAULT_APPOINTMENT_BY_DAY };
  };
}
